
// Local components
import ChevronIcon from '~/assets/icons/chevron.svg'

export default {
  name: 'ImageCarusel',
  components: {
    ChevronIcon,
  },
  props: {
    imageSources: {
      type: Array,
      default: () => []
    },
    displayId: {
      type: String,
      default: undefined
    },
    productName: {
      type: String,
      default: undefined
    },
    largeImageStyle: {
      type: Boolean,
      default: false
    },
    preload: {
      type: Boolean,
      default: false
    },
    lazyload: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      settings: {
        arrows: false,
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        speed: 500,
      },
      haveInteracted: false,
    }
  },
  computed: {
    uid () {
      return (
        Math.random().toString(36).substring(2) +
        new Date().getTime().toString(36)
      )
    },
    imageCarouselRefName () {
      return `image-carousel-${this.imageSources[0]}-${this.uid}`
    },
    imageCarouselRef () {
      return this.$refs[this.imageCarouselRefName]
    },
  },
  mounted () {
    this.$el.addEventListener('mouseenter', this.setInteracted, { passive: true })
    this.$el.addEventListener('touchstart', this.setInteracted, { passive: true })
  },
  unmounted () {
    this.$el.removeEventListener('mouseenter', this.setInteracted, { passive: true })
    this.$el.removeEventListener('touchstart', this.setInteracted, { passive: true })
  },
  methods: {
    next () {
      this.imageCarouselRef?.next()
    },
    previous () {
      this.imageCarouselRef?.prev()
    },
    setInteracted () {
      this.haveInteracted = true
    },
  }
}
